import * as actions from '../actions/themeActions'

const initialState = {
  themes: [],
  activeTheme: null,
  loading: false,
  updating: false,
  error: null,
}

const themes = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_THEMES:
    case actions.FETCH_THEME:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case actions.UPDATE_THEME:
    case actions.PUBLISH_THEME:
      return {
        ...state,
        updating: true,
        error: null,
      }

    case actions.CREATE_THEME:
    case actions.DELETE_THEME:
      return {
        ...state,
        error: null,
      }

    case actions.FETCH_THEMES_SUCCESS:
      return {
        ...state,
        themes: action.payload.themes,
        loading: false,
        error: null,
      }

    case actions.FETCH_THEME_SUCCESS:
      return {
        ...state,
        activeTheme: action.payload.theme,
        loading: false,
        error: null,
      }

    case actions.UPDATE_THEME_SUCCESS:
      return {
        ...state,
        activeTheme: action.payload.theme,
        themes: state.themes.map((theme) =>
          theme.id === action.payload.theme.id
            ? { ...theme, ...action.payload.theme }
            : theme
        ),
        updating: false,
        error: null,
      }

    case actions.PUBLISH_THEME_SUCCESS:
      return {
        ...state,
        activeTheme: action.payload.theme,
        themes: state.themes.map((theme) =>
          theme.id === action.payload.theme.id
            ? action.payload.theme
            : theme.status === 'published'
              ? { ...theme, status: 'archived' }
              : theme
        ),
        updating: false,
        error: null,
      }

    case actions.CREATE_THEME_SUCCESS:
      return {
        ...state,
        themes: [action.payload.theme, ...state.themes],
        error: null,
      }

    case actions.DELETE_THEME_SUCCESS:
      return {
        ...state,
        themes: state.themes.filter((theme) => theme.id !== action.payload.id),
        error: null,
      }

    case actions.FETCH_THEMES_ERROR:
    case actions.FETCH_THEME_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case actions.UPDATE_THEME_ERROR:
    case actions.PUBLISH_THEME_ERROR:
      return {
        ...state,
        updating: false,
        error: action.payload,
      }

    case actions.CREATE_THEME_ERROR:
    case actions.DELETE_THEME_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case actions.UNPUBLISH_THEME:
      return {
        ...state,
        updating: true,
        error: null,
      }
    case actions.UNPUBLISH_THEME_SUCCESS:
      return {
        ...state,
        activeTheme: action.payload.theme,
        themes: state.themes.map((theme) =>
          theme.id === action.payload.theme.id
            ? action.payload.theme
            : theme
        ),
        updating: false,
        error: null,
      }
    case actions.UNPUBLISH_THEME_ERROR:
      return {
        ...state,
        updating: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default themes